export default __webpack_public_path__ + "static/hero-tablet-5abbbf6060816aa5946c36c2ae83e646.png";